import { render, staticRenderFns } from "./Rule54ApplicationInstructions.vue?vue&type=template&id=080b96e6&scoped=true"
import script from "./Rule54ApplicationInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule54ApplicationInstructions.vue?vue&type=script&lang=ts"
import style0 from "./Rule54ApplicationInstructions.vue?vue&type=style&index=0&id=080b96e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b96e6",
  null
  
)

export default component.exports